import { ScaleElement } from '@scale/base-element';

class ScaleCoupon extends ScaleElement {
  async copy() {
    const code = this.dataset.code;
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch {
      const textarea = Object.assign(document.createElement('textarea'), { value: code });
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }

    const success = this.ref('success');
    if (success) {
      success.hidden = false;
      setTimeout(() => (success.hidden = true), 2000);
    }

    if (this.getBoolean('data-auto-apply')) {
      window.location.href = `/discount/${encodeURIComponent(code)}`;
    }
  }
}

if (!customElements.get('scale-coupon')) {
  customElements.define('scale-coupon', ScaleCoupon);
}
